import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import { getEventIcon } from 'src/utils/BigCalendarColourGeneratorUtils';
import './CategoryPill.scss';

interface CategoryPillProps {
  text: string;
  color?: string;
  textColor?: string;
  eventType?: string;
  enabled?: boolean;
  size?: 'normal' | 'small' | 'tiny';
  centerText?: boolean;
  iconGlyph?: string;
  iconWeight?: 'light' | 'regular' | 'solid';
  trailingSlot?: React.ReactNode;
}

const CategoryPill = ({
  text,
  color,
  textColor,
  eventType,
  enabled = true,
  size = 'normal',
  centerText = false,
  iconGlyph,
  iconWeight = 'regular',
  trailingSlot,
}: CategoryPillProps) => {
  const sizeStyles = {
    tiny: {
      fontSize: '10px',
      padding: '0px 4px',
      minHeight: '16px',
      gap: '2px',
    },
    small: {
      fontSize: '11px',
      padding: '2px 10px',
      minHeight: '18px',
      gap: '6px',
    },
    normal: {
      fontSize: '13px',
      padding: '4px 8px',
      minHeight: '24px',
      gap: '4px',
    },
  };

  const currentSizeStyle = sizeStyles[size];

  // Build className string
  const pillClasses: string = [
    'tenant_pill',
    enabled ? 'enabled' : 'disabled',
    size === 'small' ? 'tenant_pill--small' : '',
    size === 'tiny' ? 'tenant_pill--tiny' : '',
    centerText ? 'tenant_pill--center' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      className={pillClasses}
      style={
        color
          ? {
            backgroundColor: color,
            color: textColor || 'white',
            borderColor: color,
            display: 'flex',
            alignItems: 'center',
            ...currentSizeStyle,
          }
          : {
            display: 'flex',
            alignItems: 'center',
            ...currentSizeStyle,
          }
      }
    >
      {iconGlyph && <FontAwesomeIcon glyph={iconGlyph} weight={iconWeight} />}
      <span>{text}</span>
      {eventType && getEventIcon(eventType)}
      {trailingSlot}
    </span>
  );
};

export default CategoryPill;